var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skin-nav" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "skin-nav-list" },
      _vm._l(_vm.filteredComponents, function (item) {
        return _c(
          "div",
          {
            key: item.showType,
            staticClass: "skin-nav-item",
            on: {
              click: function ($event) {
                return _vm.addCompont(item)
              },
            },
          },
          [
            _c("img", { attrs: { src: item.icon, alt: item.title } }),
            _vm._v(" "),
            _c("div", { staticClass: "item-title" }, [
              _vm._v(_vm._s(item.title)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head-title flex" }, [
      _c("div", { staticClass: "dot" }),
      _vm._v(" "),
      _c("div", { staticClass: "title-text" }, [_vm._v("基础组件")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }